module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('md-tabs', {
    staticClass: "md-primary",
    attrs: {
      "md-centered": "",
      "md-elevation": "1",
      "md-dynamic-height": true
    },
    on: {
      "change": _vm.onAreaChangeDelegate
    }
  }, _vm._l((_vm.certificationProcess.areas), function(area, key) {
    return _c('md-tab', {
      key: key,
      attrs: {
        "id": ("tab-" + key),
        "md-label": area.name,
        "md-active": key === _vm.currPhotoArea
      }
    }, [_c('div', {
      attrs: {
        "md-column": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [_c('span', {
      staticClass: "md-title"
    }, [_vm._v(_vm._s(area.name) + "\n          ")]), _vm._v(" "), (area.description && area.description.trim().length > 0) ? _c('span', {
      staticClass: "caption"
    }, [_c('b', [_vm._v("Informações adicionais:")]), _vm._v(" " + _vm._s(area.description) + ".")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "caption"
    }, [_vm._v("Adicione as fotos de acordo com os items abaixo.")])]), _vm._v(" "), _c('md-list', [_c('md-subheader', {
      staticClass: "md-primary"
    }, [_vm._v("\n              VÉRTICES \n              "), _c('span', {
      staticClass: "md-caption"
    }, [_vm._v(" **"), _c('b', [_vm._v("Vértices")]), _vm._v(" são as quatro (4) quinas de cada instalação cadastrada, detalhando o ambiente como um todo."), _c('br')])]), _vm._v(" "), _vm._l((area.vertices), function(vertice, index) {
      return _c('md-list-item', {
        key: ("vertice" + index),
        on: {
          "click": function($event) {
            return _vm.addPhotos(index, vertice.type)
          }
        }
      }, [_c('div', {
        staticClass: "md-list-text-container"
      }, [_c('span', [_vm._v(_vm._s(vertice.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(vertice.description))])]), _vm._v(" "), _c('md-button', {
        staticClass: "md-icon-button md-list-action"
      }, [(vertice.status === 1) ? _c('md-icon', {
        staticClass: "done"
      }, [_vm._v("done")]) : _c('md-icon', [_vm._v("add_a_photo")])], 1), _vm._v(" "), _c('md-divider', {
        staticClass: "md-inset"
      })], 1)
    }), _vm._v(" "), (area.structures) ? _c('md-subheader', {
      staticClass: "md-primary"
    }, [_vm._v("EQUIPAMENTOS")]) : _vm._e(), _vm._v(" "), _vm._l((area.structures), function(structure, index) {
      return _c('md-list-item', {
        key: ("structure" + index),
        on: {
          "click": function($event) {
            return _vm.addPhotos(index, structure.type)
          }
        }
      }, [_c('div', {
        staticClass: "md-list-text-container"
      }, [_c('span', [_vm._v(_vm._s(structure.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(structure.description.slice(0, 35)))])]), _vm._v(" "), _c('md-button', {
        staticClass: "md-icon-button md-list-action"
      }, [(structure.status === 1) ? _c('md-icon', {
        staticClass: "done"
      }, [_vm._v("done")]) : _c('md-icon', [_vm._v("add_a_photo")])], 1), _vm._v(" "), _c('md-divider', {
        staticClass: "md-inset"
      })], 1)
    })], 2), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(_vm.isAreaFinished) ? _c('router-link', {
      staticClass: "md-raised md-primary",
      attrs: {
        "tag": "md-button",
        "to": "/syncArea"
      }
    }, [_vm._v("ENVIAR FOTOS E LIBERAR MEMÓRIA")]) : _vm._e(), _vm._v(" "), (_vm.isAreaFinished) ? _c('span', {
      staticClass: "caption"
    }, [_vm._v("*Este passo "), _c('b', [_vm._v("não é obrigatório")]), _vm._v(", porém recomendado. Após a sincronização não será possível alterar as fotos desta área.")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-row": ""
      }
    }, [_c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(key !== 0) ? _c('md-button', {
      staticClass: "md-accent md-dense",
      on: {
        "click": function($event) {
          return _vm.prevArea(key)
        }
      }
    }, [_c('span', [_c('md-icon', {
      staticClass: "md-accent"
    }, [_vm._v("arrow_left")]), _vm._v("ÁREA ANTERIOR")], 1)]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-column": ""
      }
    }, [(_vm.certificationProcess.areas.length > 1 &&
      key !== _vm.certificationProcess.areas.length - 1) ? _c('md-button', {
      staticClass: "md-accent md-dense",
      on: {
        "click": function($event) {
          return _vm.nextArea(key)
        }
      }
    }, [_c('span', [_vm._v("PRÓXIMA ÁREA "), _c('md-icon', {
      staticClass: "md-accent"
    }, [_vm._v("arrow_right")])], 1)]) : _vm._e()], 1)], 1)], 1)
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d50d8a2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/PhotosView.vue
// module id = 830
// module chunks = 1